import { Cohort } from "@/features/cohorts/types/cohorts";
import api from "@/lib/axios";

export enum CohortsKeys {
  GET_COHORTS = "get-cohorts",
  CREATE_COHORT = "create-cohort",
  GET_NEXT_COHORTS = "get-next-cohorts",
}

export const createCohort = async (payload: Partial<Cohort>) => {
  const response = await api.post("/cohorts", payload);
  return response.data as Cohort;
};

export const getAllCohorts = async () => {
  const response = await api.get("/cohorts");
  return response.data as Cohort[];
};

// Deprecated: Kept for backward compatibility
export const getCohortsByMentorId = async (mentorId: string) => {
  const response = await api.get(`/cohorts/${mentorId}`);
  return response.data as Cohort[];
};

export const getNextCohorts = async () => {
  const response = await api.get("/cohorts/next");
  return response.data as Cohort[];
};
